module.exports = __webpack_public_path__ + "img/lotPlaceholder.17b16f6.svg";